import script from "./SavePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SavePage.vue?vue&type=script&setup=true&lang=js"

import "./SavePage.vue?vue&type=style&index=0&id=07a549cf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a549cf"]])

export default __exports__